/*
 * Public API Surface of med-auto-test-id
 */

export * from "./lib/directives/med-e2e-test-id.directive";
export * from "./lib/med-e2e-test-id.module";
